import { render, staticRenderFns } from "./ListPessoas.vue?vue&type=template&id=5141f723&scoped=true&"
import script from "./ListPessoas.vue?vue&type=script&lang=js&"
export * from "./ListPessoas.vue?vue&type=script&lang=js&"
import style0 from "./ListPessoas.vue?vue&type=style&index=0&id=5141f723&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141f723",
  null
  
)

export default component.exports